module.exports = __webpack_public_path__ + "static/media/header.e5537bbe.png";